<script setup lang="ts">
import type { Player } from '@acepoker/contract'
import CodeInput from './shared/forms/CodeInput.vue'
import Modal from './shared/Modal.vue'
import InitialAssessmentForm from './shared/forms/InitialAssessment.vue'
import { useLoginWithCode } from '@/composables/useLoginWithCode'
import { useMultiStepFormNavigation } from '@/composables/useMultiStepFormNavigation'
import { toRef } from 'vue'

const props = defineProps<{
  isOpen: boolean
  onSuccess: (player: Player) => void
  onError?: (error: string) => void
  onClose?: () => void
  hideCloseButton?: boolean
  onKeepPracticing?: () => void
  onContinueWithoutSaving?: () => void
}>()

const {
  isCodeSent,
  countdown,
  email,
  pinError,
  errors,
  handleComplete,
  onSendCode,
  close: closeLogin
} = useLoginWithCode(
  (player) => {
    props.onSuccess(player)
  },
  (error) => {
    if (props.onError) props.onError(error)
  }
)

useMultiStepFormNavigation(isCodeSent, false, toRef(props, 'isOpen'))

const close = () => {
  closeLogin()
  if (props.onClose) props.onClose()
}
</script>

<template>
  <Modal :isOpen="isOpen" :hideCloseButton="hideCloseButton" :onClose="close">
    <template v-if="!isCodeSent">
      <InitialAssessmentForm
        :email="email"
        :onSendCode="onSendCode"
        :onEmailChange="(newEmail) => (email = newEmail)"
        :onKeepPracticing="props.onKeepPracticing"
        :onContinueWithoutSaving="props.onContinueWithoutSaving"
        :isCodeSent="isCodeSent"
        :countdown="countdown"
        :errors="errors"
      />
    </template>

    <template v-else>
      <CodeInput
        :error="pinError"
        :countdown="countdown"
        :onResendCode="onSendCode"
        :email="email"
        @complete="handleComplete"
      />
    </template>
  </Modal>
</template>
